/* eslint-disable react/no-unknown-property */
import React, { forwardRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import styles from './NavLink.module.scss';

interface INavLinkProps {
  className?: string;
  path?: string;
  title?: string;
  beta?: boolean;
  disabled?: boolean
  hidden?: boolean
  Icon?: React.ComponentType;
  qaElement?: string
  onClick?: () => void;
}

const NavLink = forwardRef<HTMLButtonElement, INavLinkProps>(({
  className,
  path,
  title,
  Icon,
  beta,
  disabled,
  hidden,
  onClick,
  qaElement,
}, ref) => {
  const location = useLocation();

  const activeKey = React.useMemo(
    () => location.pathname.split('/').splice(0, 3).join('/'),
    [location],
  );

  if (path) {
    return (
      <Link
        className={classnames(
          styles.navLink,
          className,
          {
            [styles.active]: activeKey === path,
            [styles.hidden]: hidden,
            [styles.disabled]: disabled,
            [styles.onlyIcon]: Icon && !title,
          },
        )}
        to={path || '#'}
        qa-element={qaElement}
      >
        {Icon ? <Icon /> : <div />}
        <span>
          {title}
        </span>
        {beta && <div className={styles.beta}>beta</div>}
      </Link>
    );
  }

  return (
    <button
      ref={ref}
      type="button"
      className={classnames(
        styles.navLink,
        className,
        {
          [styles.active]: activeKey === path,
          [styles.hidden]: hidden,
          [styles.disabled]: disabled,
          [styles.onlyIcon]: Icon && !title,
        },
      )}
      onClick={onClick}
      qa-element={qaElement}
    >
      {Icon ? <Icon /> : <div />}
      <span>
        {title}
      </span>
      {beta && <div className={styles.beta}>beta</div>}
    </button>
  );
});
export default NavLink;
